module.exports = "<automation-header></automation-header>\r\n<div>\r\n  <div [ngStyle]=\"{'display': (registerSpinner) ? 'none':'block'}\">\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n\r\n  <div *ngIf=\"registerSpinner\" class=\"loader loader-style\" style=\"margin-top:150px;\">\r\n    <div class=\"new-loader loader-1\">\r\n      <div class=\"loader-outter\"></div>\r\n      <div class=\"loader-inner\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/automation/automation.component.html
// module id = ./src/app/automation/automation.component.html
// module chunks = main